
export default {
  name: 'ClientsReviewsSlider',
  props: {
    reviews: {
      type: Array,
      default: () => [],
    },
    slidesPerPage: {
      type: Number,
      default: 4,
    },
    variant: {
      type: String,
      default: 'carousel',
      validator: v => ['carousel', 'spotlight'].includes(v),
    },
  },
  data() {
    return {
      selectedReview: null,
      isDragging: false,
      touchStartX: 0,
      spotlightDragging: false,
      spotlightStartX: 0,
      spotlightScrollLeft: 0,
      spotlightDragDistance: 0,
      showSpotlightLeftArrow: false,
      showSpotlightRightArrow: true,
      mouseStartX: 0,
      mouseStartY: 0,
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.updateSpotlightArrows()
      const carousel = this.$refs.carousel
      if (!carousel) return
      let dragStartPos = null
      let unlocked = false
      carousel.$el.addEventListener('mousedown', (e) => {
        dragStartPos = { x: e.pageX, y: e.pageY }
        unlocked = false
      }, true)
      const originalMove = carousel.onPointerMove
      carousel.onPointerMove = function (e) {
        if (!unlocked && dragStartPos) {
          const x = e.pageX || 0
          const y = e.pageY || 0
          if (Math.abs(x - dragStartPos.x) < 10 && Math.abs(y - dragStartPos.y) < 10) return
          unlocked = true
        }
        originalMove(e)
      }
    })
  },
  computed: {
    displayedReviews() {
      const reviewsWithMedia = this.reviews.filter(
        review =>
          review.images?.length > 0 || review.movies?.[0]?.image?.url
      )
      const maxReviews = this.$device.isMobile ? 10 : 20
      return reviewsWithMedia.slice(0, maxReviews)
    },
    spotlightReviews() {
      const reviewsWithMedia = this.reviews.filter(
        review =>
          review.images?.length > 0 || review.movies?.[0]?.image?.url
      )
      return reviewsWithMedia.slice(0, 20)
    },
    shouldCenterReviews() {
      if (this.variant === 'spotlight') return false
      if (this.$device.isMobile || this.$device.isTablet) {
        return (
          this.displayedReviews.length > 0 && this.displayedReviews.length <= 4
        )
      }
      return (
        this.displayedReviews.length > 0 &&
        this.displayedReviews.length < this.slidesPerPage
      )
    },
    featuredsImage() {
      return function (review, srcset) {
        if (review?.movies?.[0]?.image?.url) {
          return srcset
            ? [
                `${this.$cropUrl(
                  review.movies[0].image,
                  520,
                  520,
                  review.movies[0].image.extension,
                  86
                )} 1x`,
                `${this.$cropUrl(
                  review.movies[0].image,
                  1024,
                  1024,
                  review.movies[0].image.extension,
                  86
                )} 2x`,
              ]
            : this.$cropUrl(
                review.movies[0].image,
                520,
                520,
                review.movies[0].image.extension,
                86
              )
        }
        return srcset
          ? [
              `${this.$cropUrl(
                review.images[0],
                520,
                520,
                review.images[0].extension,
                86
              )} 1x`,
              `${this.$cropUrl(
                review.images[0],
                1024,
                1024,
                review.images[0].extension,
                86
              )} 2x`,
            ]
          : this.$cropUrl(
              review.images[0],
              520,
              520,
              review.images[0].extension,
              86
            )
      }
    },
  },
  methods: {
    spotlightRotation(index) {
      const rotations = [
        'tw-rotate-2',
        '-tw-rotate-2',
        'tw-rotate-2',
        'tw-rotate-2',
        '-tw-rotate-2',
        'tw-rotate-2',
        '-tw-rotate-2',
      ]
      return rotations[index % rotations.length]
    },
    reviewUserName(review) {
      if (!review) return 'Anonyme'
      return (
        review.user?.fullname_anonymous ||
        review.user_fullname ||
        review.user_firstname ||
        'Anonyme'
      )
    },
    reviewMediaLabel(review) {
      const name = this.reviewUserName(review)
      const message = (review?.message || '').trim()
      if (!message) return name
      const excerpt =
        message.length > 60 ? `${message.slice(0, 60).trim()}…` : message
      return `${name} : ${excerpt}`
    },
    onDragStart() {
      this.isDragging = true
    },
    onDragEnd() {
      setTimeout(() => {
        this.isDragging = false
      }, 50)
    },
    onTouchStart(e) {
      this.touchStartX = e.touches[0].clientX
      this.isDragging = false
    },
    onTouchEnd(e, review) {
      const touchEndX = e.changedTouches[0].clientX
      const diff = Math.abs(touchEndX - this.touchStartX)
      if (diff < 10 && !this.isDragging) {
        this.selectedReview = review
        this.$bvModal.show('modalReview')
      }
    },
    onMouseDown(e) {
      this.mouseStartX = e.clientX
      this.mouseStartY = e.clientY
    },
    onMouseUp(e, review) {
      const diffX = Math.abs(e.clientX - this.mouseStartX)
      const diffY = Math.abs(e.clientY - this.mouseStartY)
      if (diffX < 50 && diffY < 50) {
        this.selectedReview = review
        this.$nextTick(() => {
          this.$bvModal.show('modalReview')
        })
      }
    },
    openReviewModal(review) {
      this.selectedReview = review
      this.$bvModal.show('modalReview')
    },
    openSpotlightReview(review) {
      if (this.spotlightDragDistance > 5) return
      this.selectedReview = review
      this.$bvModal.show('modalReview')
    },
    onSpotlightMouseDown(e) {
      this.spotlightDragging = true
      this.spotlightDragDistance = 0
      this.spotlightStartX = e.pageX
      this.spotlightScrollLeft = this.$refs.spotlightContainer.scrollLeft
    },
    onSpotlightMouseMove(e) {
      if (!this.spotlightDragging) return
      e.preventDefault()
      const dx = e.pageX - this.spotlightStartX
      this.spotlightDragDistance = Math.abs(dx)
      this.$refs.spotlightContainer.scrollLeft = this.spotlightScrollLeft - dx
    },
    onSpotlightMouseUp() {
      this.spotlightDragging = false
    },
    scrollSpotlight(direction) {
      const container = this.$refs.spotlightContainer
      if (!container) return
      const scrollAmount = container.clientWidth * 0.7
      container.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      })
    },
    updateSpotlightArrows() {
      const container = this.$refs.spotlightContainer
      if (!container) return
      this.showSpotlightLeftArrow = container.scrollLeft > 10
      this.showSpotlightRightArrow =
        container.scrollLeft < container.scrollWidth - container.clientWidth - 10
    },
  },
}
